<template>
  <b-modal
    @show="onShow"
    header-class="dlg_header no_border"
    :visible="visible"
    centered
    contentClass="md-confirm-content"
    bodyClass= "confirm-body pt-0"
    footerClass= "confirm-footer"
    :okTitle= "$t('common.ok')"
    :cancelTitle= "$t('common.cancel1')"
    okVariant= "primary md_btn_primary"
    cancelVariant= "secondary md_btn_light"
    @ok="onConfirm"
    @hidden="onCancel"
  >
    <template #modal-header="{close}">
      <div class="popup_title titleLabel"
           :class="{'underline' : type == 'LG'}"
           style="flex: 1; text-align: center;">{{title}}</div>
    </template>
    <div class="full container" style="overflow-y: auto">
      <div class="align-vertical pb-2">
        <div class="width_100 h_center">
          <span class="contentLabel">{{message}}</span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
export default {
  name: "ConfirmPopupGroup",
  components: {},
  data() {
    return {
      self: this,
      u: Utils,
      visible: false,
      title: '',
      message: '',
      onConfirm: () => {},
      type: 'LG',
    }
  },
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  methods: {
    onShow() {
    },
    onCancel() {
      this.visible=false;
    },
    show (title, message, type, onConfirm) {
      Utils.setState(this,{
        title: title,
        message: message,
        onConfirm: onConfirm,
        type: type,
        visible: true,
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";
.titleLabel {
  font-size: $fs_22;
  color: $black;
  text-align: center;
  font-family: $korean_gd_16_r;
}
.underline {
  text-decoration-line: underline;
  text-decoration-color: $trading1;
}
.contentLabel {
  font-size: $fs_20;
  color: $trading1;
  text-align: center;
  line-height: 27px;
  font-family: $korean_gd_14_r;
}
</style>


// WEBPACK FOOTER //
// src/components/controls/popup/ConfirmPopupGroup.vue